import { getSignedUrlByKeyAsync } from "api/document";

/**
 * Open a user-doc S3 object in a new tab using a presigned URL fetched from the
 * an-api backend (no direct AWS access in the browser).
 *
 * @param {Object} documentData
 * @param {string} [documentData.cognitoId]
 * @param {string} documentData.filename - filename, or full key when `isVersioned`
 * @param {string} [documentData.versionId]
 * @param {boolean} [isVersioned] - when true, `filename` is the full object key
 */
export const openS3Document = async (documentData, isVersioned) => {
  const { cognitoId, filename, versionId } = documentData;
  const response = await getSignedUrlByKeyAsync({
    cognitoId: isVersioned ? undefined : cognitoId,
    filename,
    versionId,
    keyIsFullPath: !!isVersioned,
  });
  const url = response.data?.url;
  if (!url) {
    throw new Error("openS3Document: response did not contain a signed url");
  }
  window.open(url, "_blank", "noopener,noreferrer");
};
